function btoa(string) {
	return Buffer.from(string).toString('base64')
}

function atob(string) {
	return Buffer.from(string, 'base64').toString()
}

function encrypt(token) {
	return btoa(btoa(token)).replace(/=/g, '')
}

function decrypt(token) {
	return atob(atob(token))
}

module.exports = {
	encrypt,
	decrypt
}
